import VisitorImporter from './src/main';

/* istanbul ignore next */
VisitorImporter.install = function(Vue) {
  Vue.component(VisitorImporter.name, VisitorImporter);
};

export default VisitorImporter;
